var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success","small":""},on:{"click":_vm.addCanteenRestaurant}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_vm._v(" "+_vm._s(_vm.$t('actions.add'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }